import {
    ANALYTICS_PAGE_LOAD,
    ANALYTICS_CLICK_EVENT,
    UPDATE_ANALYTICS_CLICK_EVENT,
    DIGITAL_ANALYTICS_PAGE_LEVEL_DATA,
    PUT_ANALYTICS_CLICK_EVENT_STACK,
    TOGGLE_SHIPPING_TYPE_ANALYTICS_ACTION,
    PLCC_BANNER_UPDATE_DATA,
    ANALYTICS_CLICK_ORDER_SUMMARY_SCC,
    ANALYTICS_CLICK_GIFT_CARD_BANNER,
    GOOGLE_CAPTCHA_ANALYTICS_EVENT,
    PLCC_CLICK_EVENT_ACTION,
    TRIGGER_AUTH_ANALYTICS,
    SET_AUTH_ANALYTICS,
} from '../actionTypes/CheckoutAnalyticsActionTypes';

export const pageLoadSuccessAnalyticsAction = (pageName) => ({
    type: ANALYTICS_PAGE_LOAD,
    pageName,
});

export const clickEventAnalyticsAction = (payload) => ({
    type: ANALYTICS_CLICK_EVENT,
    payload,
});

export const updateAnalyticsClickAction = (payload) => ({
    type: UPDATE_ANALYTICS_CLICK_EVENT,
    payload,
});

export const putAnalyticsClickEventStack = (payload) => ({
    type: PUT_ANALYTICS_CLICK_EVENT_STACK,
    payload,
});

// keep page level analytics data at one place for convenience
export const digitalAnalyticsData = (payload) => ({
    type: DIGITAL_ANALYTICS_PAGE_LEVEL_DATA,
    payload,
});

// when user toggle from ship to HOME to ship to STORE on shipping accordion, trigger this event
export const toggleShippingTypeAnalyticsAction = () => ({
    type: TOGGLE_SHIPPING_TYPE_ANALYTICS_ACTION,
});

export const orderSummaryChevron = () => ({
    type: ANALYTICS_CLICK_ORDER_SUMMARY_SCC,
});

export const plccBannerUpdateAction = (bannerName) => ({
    type: PLCC_BANNER_UPDATE_DATA,
    bannerName,
});

export const giftCardBannerAnalyticsAction = () => ({
    type: ANALYTICS_CLICK_GIFT_CARD_BANNER,
});

export const triggerCaptchaAnalytics = (payload) => ({
    type: GOOGLE_CAPTCHA_ANALYTICS_EVENT,
    payload,
});

export const plccClickEventAction = (payload) => ({
    type: PLCC_CLICK_EVENT_ACTION,
    payload,
});

export const triggerAuthAnalytics = (payload) => ({
    type: TRIGGER_AUTH_ANALYTICS,
    payload,
});
export const setAuthAnalytics = (payload) => ({
    type: SET_AUTH_ANALYTICS,
    payload,
});
export default {
    pageLoadSuccessAnalyticsAction,
    clickEventAnalyticsAction,
    updateAnalyticsClickAction,
    digitalAnalyticsData,
    putAnalyticsClickEventStack,
    toggleShippingTypeAnalyticsAction,
    giftCardBannerAnalyticsAction,
    triggerCaptchaAnalytics,
    triggerAuthAnalytics,
    setAuthAnalytics,
};
